import { ARE_POPUPS_BLOCKED } from "./PopupBlockerActions";

const initialState = {
  arePopupsBlocked: false
};

export const popupBlockerReducer = (state = initialState, action = {}) => {
  if (action.type === ARE_POPUPS_BLOCKED) {
    return { ...state, arePopupsBlocked: action.payload };
  }
  return { ...state };
};
